export default __webpack_public_path__ + "static/media/join-form-desktop-background.de92a291.jpg";